



























import { Component } from 'vue-property-decorator';

import { Gradient } from '@/components/wobble/model';
import Chapter from './Chapter.vue';
import FloatingWobble from '@/components/wobble/FloatingWobble.vue';

@Component({
  components: {
    FloatingWobble,
  }
})
export default class Greatful extends Chapter {
  public wobbleGradient = new Gradient(
    '#e96b10',
    '#fce417',
    0.0,
    1.0,
    420.97,
    -235.8,
    147.67,
    535.89,
  );
}
